import { useEffect } from 'react';
import { isEditableKeyboardTarget, isLanguageToggleShortcut } from '../i18n/languageKeyboard';
import { useLanguage } from '../i18n';

/** Global Alt+Shift+L shortcut to cycle UI language (desktop / hardware keyboards). */
export function useLanguageToggleShortcut(): void {
  const { toggleLanguage } = useLanguage();

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (!isLanguageToggleShortcut(event)) {
        return;
      }
      if (isEditableKeyboardTarget(event.target)) {
        return;
      }
      event.preventDefault();
      toggleLanguage();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [toggleLanguage]);
}
